
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Jyotilingayatrafrompune() {



    const cardData =
    {
        keyword: '12 Jyotirlinga Yatra from Pune',
        heading: 'S9 Travels: 12 Jyotirlinga Yatra from Pune',
        headingDescription: 'S9 Travels offers exclusive and comfortable taxi services for the 12 Jyotirlinga Yatra from Pune. The 12 Jyotirlingas are sacred shrines dedicated to Lord Shiva and are spread across different parts of India. A pilgrimage to these holy temples offers a spiritual journey, connecting devotees with the divine and providing a serene and peaceful experience.',

        top: 'Top 12 Jyotirlinga Temples and Their Locations',

        "topPlaces": [
    {
      "title": "Somnath (Gujarat)",
      "description": "Located on the west coast of India, Somnath is the first of the 12 Jyotirlingas. The temple is famous for its historical significance and stunning seaside views. It’s known as a symbol of resilience, having been destroyed and rebuilt several times."
    },
    {
      "title": "Mallikarjuna (Andhra Pradesh)",
      "description": "Situated on the Shri Shaila Mountain, Mallikarjuna Jyotirlinga is one of the most revered temples in the region. It's located in the town of Srisailam and is a major pilgrimage site."
    },
    {
      "title": "Mahakaleshwar (Madhya Pradesh)",
      "description": "Located in Ujjain, Mahakaleshwar is a famous temple where Lord Shiva is worshipped in the form of an idol that is considered to be self-originated. The temple’s Bhasm Aarti is a unique experience for devotees."
    },
    {
      "title": "Omkareshwar (Madhya Pradesh)",
      "description": "Omkareshwar is situated on the Mandhata Island in the Kshipra River. The temple here is shaped like the Hindu symbol 'Om', adding to its spiritual significance."
    },
    {
      "title": "Kedarnath (Uttarakhand)",
      "description": "Kedarnath is located in the Himalayas and is one of the most important temples for Hindus. It is known for its high-altitude temple and breathtaking views. The journey to Kedarnath is a spiritual and physically demanding one."
    },
    {
      "title": "Bhimashankar (Maharashtra)",
      "description": "Located near Pune, Bhimashankar is surrounded by lush greenery and is the perfect spiritual retreat. It’s one of the closest Jyotirlingas to Pune and an ideal starting point for the Yatra."
    },
    {
      "title": "Kashi Vishwanath (Uttar Pradesh)",
      "description": "Situated in Varanasi, one of the oldest cities in the world, the Kashi Vishwanath Temple is one of the most important spiritual places in India. Devotees come to Kashi to experience the divine energy of Lord Shiva."
    },
    {
      "title": "Trimbakeshwar (Maharashtra)",
      "description": "Located near Nashik, Trimbakeshwar is famous for its unique 'Trimbak' or three-faced idol of Lord Shiva, symbolizing the three forms of the divine - Brahma, Vishnu, and Shiva."
    },
    {
      "title": "Vaidyanath (Jharkhand or Bihar)",
      "description": "Vaidyanath is associated with healing and health. The temple is located in Deoghar (Jharkhand) and also in Parli (Maharashtra), with both locations holding significant importance in the Yatra."
    },
    {
      "title": "Nageshwar (Gujarat)",
      "description": "Situated near Dwarka, Nageshwar is known for its majestic architecture and the strong belief that it protects devotees from poisonous creatures. It is one of the holiest places in Gujarat."
    }
  ],

  "services": [
    {
      "name": "12 Jyotirlinga Yatra Cab from Pune",
      "description": "S9 Travels offers reliable and comfortable cab services for your 12 Jyotirlinga Yatra from Pune. Embark on a spiritual journey with a professional driver and well-maintained vehicle, ensuring a smooth and hassle-free trip to all 12 Jyotirlinga temples."
    },
    {
      "name": "Pune to 12 Jyotirlinga Yatra",
      "description": "Travel from Pune to the sacred 12 Jyotirlinga temples with S9 Travels. Our well-maintained vehicles and experienced drivers guarantee a comfortable and safe journey throughout your spiritual trip to all the holy destinations."
    },
    {
      "name": "12 Jyotirlinga Yatra Package from Pune",
      "description": "S9 Travels offers comprehensive 12 Jyotirlinga Yatra packages from Pune. Whether you want a custom itinerary or a pre-designed package, we provide flexible and affordable options for your pilgrimage tour."
    },
    {
      "name": "Pune to Jyotirlinga Yatra Tour",
      "description": "Start your Jyotirlinga Yatra tour from Pune with S9 Travels. We provide the best cab services for a smooth, spiritual, and comfortable journey to all the sacred Jyotirlinga temples across India."
    },
    {
      "name": "Pune to 12 Jyotirlinga Temple Cab",
      "description": "Choose S9 Travels for a specialized cab service from Pune to the 12 Jyotirlinga temples. Our professional drivers and comfortable vehicles ensure that your spiritual journey is both peaceful and convenient."
    },
    {
      "name": "Pune to Jyotirlinga Yatra Booking",
      "description": "Booking your Jyotirlinga Yatra with S9 Travels is simple and convenient. Whether online or over the phone, we offer flexible booking options to suit your schedule. Book your trip from Pune to the 12 Jyotirlinga temples today!"
    },
    {
      "name": "12 Jyotirlinga Yatra Tour from Pune",
      "description": "Embark on a spiritual journey with S9 Travels' 12 Jyotirlinga Yatra Tour from Pune. We provide fully customizable and comfortable tour packages to the sacred temples, offering a smooth and peaceful pilgrimage experience."
    },
    {
      "name": "12 Jyotirlinga Yatra Car Rental",
      "description": "S9 Travels offers car rental services for your 12 Jyotirlinga Yatra. Rent a car for a comfortable, private, and flexible journey from Pune to the Jyotirlinga temples, traveling at your own pace with expert drivers."
    },
    {
      "name": "Pune to Jyotirlinga Yatra Private Taxi",
      "description": "If you prefer a private and personalized experience, S9 Travels provides private taxis for your Jyotirlinga Yatra from Pune. Travel in comfort and privacy with a dedicated driver to take you to all the temples on your journey."
    },
    {
      "name": "Affordable 12 Jyotirlinga Tour",
      "description": "S9 Travels offers an affordable 12 Jyotirlinga Yatra tour from Pune without compromising on comfort or service quality. We ensure a seamless spiritual journey to all 12 Jyotirlinga temples at competitive prices."
    },
    {
      "name": "12 Jyotirlinga Yatra Round Trip from Pune",
      "description": "S9 Travels provides a convenient round-trip service for your 12 Jyotirlinga Yatra from Pune. We ensure a comfortable journey with professional drivers and reliable vehicles, allowing you to complete your pilgrimage and return safely to Pune."
    },
    {
      "name": "12 Jyotirlinga Yatra Booking Service",
      "description": "For your 12 Jyotirlinga Yatra from Pune, S9 Travels offers a simple and efficient booking service. Book your pilgrimage journey easily online or by phone, and get all the necessary details for a hassle-free experience."
    },
    {
      "name": "12 Jyotirlinga Yatra Taxi Fare",
      "description": "S9 Travels offers transparent taxi fares for your 12 Jyotirlinga Yatra from Pune. We ensure competitive pricing with no hidden charges, so you can plan your journey with confidence and peace of mind."
    },
    {
      "name": "Group Booking for Jyotirlinga Yatra",
      "description": "Traveling with a group? S9 Travels offers group bookings for the 12 Jyotirlinga Yatra. Whether for a family, friends, or organized tour, we provide affordable and comfortable group travel options for your spiritual pilgrimage."
    }
  ],


"tableData": [
  ["12 Jyotirlinga Yatra Cab from Pune", "Pune To 12 Jyotirlinga Yatra"],
  ["12 Jyotirlinga Yatra Package from Pune", "Pune To Jyotirlinga Yatra Tour"],
  ["Pune to 12 Jyotirlinga Temple Cab", "Pune To Jyotirlinga Yatra Booking"],
  ["12 Jyotirlinga Yatra Tour from Pune", "12 Jyotirlinga Yatra Car Rental"],
  ["Pune to Jyotirlinga Yatra Private Taxi", "Affordable 12 Jyotirlinga Tour"],
  ["12 Jyotirlinga Yatra Round Trip from Pune", "12 Jyotirlinga Yatra Booking Service"],
  ["12 Jyotirlinga Yatra Taxi Fare", "Group Booking for Jyotirlinga Yatra"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the significance of the 12 Jyotirlinga Yatra. We ensure timely pickups and drop-offs, helping you follow your sacred journey without any delays. Whether you’re traveling to one or all of the Jyotirlingas, we make sure your pilgrimage is smooth and timely."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We provide a range of comfortable vehicles to suit your needs, including sedans, SUVs, and buses. All vehicles are air-conditioned and spacious, ensuring that your journey is peaceful and comfortable, even on long trips."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes to all the Jyotirlingas and are committed to providing a safe and smooth journey. They are professional, courteous, and ensure you have a hassle-free experience as you visit these sacred shrines."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for the 12 Jyotirlinga Yatra. We provide transparent pricing with no hidden charges. Our pricing structure is clear, and we ensure you know the costs upfront, so there are no surprises along the way."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. Our vehicles are equipped with modern safety features, including airbags, seat belts, and GPS tracking, ensuring a secure and peaceful journey as you travel to each of the 12 Jyotirlingas."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "We are available around the clock for the 12 Jyotirlinga Yatra. Whether you're planning to start early in the morning or return late at night, our services are available to suit your schedule. We ensure flexibility, comfort, and convenience for your spiritual journey."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your 12 Jyotirlinga Yatra with S9 Travels is quick and easy. You can easily book online via our website or mobile app, or contact our customer service team for personalized assistance and itinerary planning."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We offer customized travel packages for the 12 Jyotirlinga Yatra, allowing you to visit all or select Jyotirlingas based on your preferences. Let us know your requirements, and we’ll tailor the trip to suit your spiritual journey."
  }
]





















    }



    const faqData = [
        [
          {
            question: 'How can I book the 12 Jyotirlinga Yatra from Pune with S9 Travels?',
            answer: 'Booking is simple! You can book online through our website or app, or you can contact our customer service team to get personalized assistance and help with planning your Yatra.',
          },
          {
            question: 'What types of vehicles are available for the 12 Jyotirlinga Yatra from Pune?',
            answer: 'We offer a range of vehicles, including sedans, SUVs, and buses, all well-maintained and designed to provide comfort during your long journey.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel to the 12 Jyotirlingas?',
            answer: 'Yes, all our drivers are highly experienced and familiar with the routes to all the Jyotirlingas. They are committed to providing you with a smooth and safe journey throughout the Yatra.',
          },
          {
            question: 'How do I pay for my 12 Jyotirlinga Yatra cab rental from Pune?',
            answer: 'We offer multiple payment options, including cash, credit/debit cards, and online payments via our app, making it easy and convenient for you to pay for your Yatra.',
          },
          {
            question: 'Can I book a round-trip for the 12 Jyotirlinga Yatra from Pune?',
            answer: 'Yes, we offer round-trip services for the 12 Jyotirlinga Yatra. Simply provide us with your return details, and we’ll ensure a smooth and hassle-free trip.',
          },
          {
            question: 'Are there any extra charges for detours or waiting times during the Yatra?',
            answer: 'Any extra charges for detours, waiting times, or changes in the itinerary will be communicated to you upfront, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a vehicle for sightseeing during the Yatra?',
            answer: 'Yes, we offer sightseeing services as part of your 12 Jyotirlinga Yatra. Our experienced drivers can guide you through the main attractions and points of interest near the Jyotirlingas.',
          },
          {
            question: 'What is the luggage allowance for the 12 Jyotirlinga Yatra from Pune?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have more luggage or special requirements, please inform us during the booking process, and we will make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate or group travel for the 12 Jyotirlinga Yatra?',
            answer: 'Yes, we offer corporate and group travel services for the 12 Jyotirlinga Yatra. Whether it’s for a group of devotees or a family, we ensure a comfortable and safe journey for everyone.',
          },
          {
            question: 'Why should I choose S9 Travels for the 12 Jyotirlinga Yatra from Pune?',
            answer: 'S9 Travels guarantees a reliable, comfortable, and affordable pilgrimage experience with professional drivers, well-maintained vehicles, and excellent customer service. We prioritize your comfort and safety throughout the journey, ensuring you have a stress-free and spiritually fulfilling Yatra.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Rajesh Sharma',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“We booked S9 Travels for our 12 Jyotirlinga Yatra, and the experience was wonderful. The vehicle was clean and comfortable, and the driver was very experienced. It was a seamless journey, and we felt safe and well taken care of.”',
        },
        {
          name: 'Mrs. Priya Deshmukh',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family had a memorable trip to the 12 Jyotirlingas with S9 Travels. The journey was smooth, and the driver was very professional. The vehicle was comfortable, and we felt completely at ease throughout the trip.”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "12 Jyotirlinga Yatra From Pune",
        "description": "Book your 12 Jyotirlinga Yatra from Pune with S9 Travels. Choose from affordable taxi, private cabs, and car rental services for a comfortable and spiritual journey across the 12 Jyotirlinga temples. Get the best fares for a complete 12 Jyotirlinga Yatra package with round trip options, group bookings, and more.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
   
      
      
      


    return (
        <div>
            
      <Helmet>
        <title>12 Jyotirlinga Yatra From Pune | Affordable Taxi & Cab Booking | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book 12 Jyotirlinga Yatra from Pune with affordable taxi services, private cabs, car rentals, and round-trip bookings. Get the best deals for 12 Jyotirlinga Yatra packages, including group bookings, temple tours, and more with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/19.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>

                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Jyotilingayatrafrompune;